import { ajaxPost, parceAjaxErrorResponse } from "../utils";
import { ErrorSwal, SuccessSwal, SwalPost } from "../../app";
import { bsModal } from "../plugins";

$(function () {
  const body = $("body");

  if (body.hasClass("celery-tasks-list")) {
    const table = $("#taskListTable");
    const form = $("#taskFilterForm");

    table.DataTable({
      pageLength: 50,
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
      $(body).modal("hideAll");
    });

    $(document).on("click", ".rowActionMenuBtn", (e) => {
      const btn = $(e.currentTarget);
      const rowId = btn.closest("tr").attr("id");
      const menu = btn.parent().find(".rowActionMenu");

      ajaxPost(rowId + "/action-buttons/", {}, btn).then((response) => {
        menu.html(String(response["html"]));
      });
    });
  }

  if (
    body.hasClass("celery-tasks-list") ||
    body.hasClass("travel-policy-detail")
  ) {
    const table = $("#taskListTable");

    $(document).on("click", ".taskDetailBtn", (e) => {
      e.preventDefault();
      const taskId = $(e.currentTarget).data("task-id");

      const modal = bsModal("full", {
        title: "Task Detail",
        modalId: "taskDetailModal",
        backdrop: "none",
      });

      const data = {
        task_id: taskId,
        action: "detail_modal",
      };

      ajaxPost(window.location.pathname + "ajax/", data)
        .then((response) => {
          $(modal).modal("content", response["html"]);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on("click", ".requeueTaskBtn", (e) => {
      e.preventDefault();
      const taskId = $(e.currentTarget).data("task-id");

      const data = {
        task_id: taskId,
        action: "requeue",
      };

      SwalPost(window.location.pathname + "ajax/", data).then((response) => {
        $(document).modal("hideAll");

        try {
          table.DataTable().ajax.reload();
        } catch (error) {}
        SuccessSwal.fire({ timer: 1000 });
      });
    });

    $(document).on("click", ".deleteTaskBtn", (e) => {
      e.preventDefault();
      const taskId = $(e.currentTarget).data("task-id");

      const data = {
        task_id: taskId,
        action: "delete",
      };

      SwalPost(window.location.pathname + "ajax/", data).then((response) => {
        $(document).modal("hideAll");

        try {
          table.DataTable().ajax.reload();
        } catch (error) {
          console.error("Error reloading table:", error);
          $(`#task-row-${taskId}`).remove();
        }

        SuccessSwal.fire({ timer: 1000 }).then();
      });
    });
  }
});
